var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPainScore0(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.524,
    height: 80.525,
    viewBox: "0 0 80.524 80.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-painscore0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3584",
    "data-name": "Path 3584",
    d: "M79.024-30.237A39.263,39.263,0,0,1,39.762,9.025,39.263,39.263,0,0,1,.5-30.237,39.263,39.263,0,0,1,39.762-69.5,39.263,39.263,0,0,1,79.024-30.237",
    transform: "translate(-0.5 69.5)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2-painscore0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3589",
    "data-name": "Path 3589",
    d: "M31.795-44.623a2.633,2.633,0,0,1-2.633,2.633,2.633,2.633,0,0,1-2.633-2.633,2.633,2.633,0,0,1,2.633-2.633,2.633,2.633,0,0,1,2.633,2.633",
    transform: "translate(-26.529 47.256)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3-painscore0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3595",
    "data-name": "Path 3595",
    d: "M30.031-44.831a1.078,1.078,0,0,1-1.078,1.078,1.078,1.078,0,0,1-1.077-1.078,1.077,1.077,0,0,1,1.077-1.077,1.078,1.078,0,0,1,1.078,1.077",
    transform: "translate(-27.876 45.908)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4-painscore0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3598",
    "data-name": "Path 3598",
    d: "M42.787-43.845a2.633,2.633,0,0,1-2.633,2.633,2.633,2.633,0,0,1-2.633-2.633,2.633,2.633,0,0,1,2.633-2.633,2.633,2.633,0,0,1,2.633,2.633",
    transform: "translate(-37.521 46.478)",
    fill: "#00142e",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5-painscore0"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3601",
    "data-name": "Path 3601",
    d: "M41.023-44.053a1.078,1.078,0,0,1-1.077,1.078,1.079,1.079,0,0,1-1.078-1.078,1.078,1.078,0,0,1,1.078-1.077,1.077,1.077,0,0,1,1.077,1.077",
    transform: "translate(-38.868 45.13)",
    fill: "#00142e",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pain_0",
    "data-name": "Pain 0",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3751",
    "data-name": "Group 3751",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-painscore0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3583",
    "data-name": "Path 3583",
    d: "M-.5-70.5H80.333V10.334H-.5Z",
    transform: "translate(-0.654 69.346)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3753",
    "data-name": "Group 3753",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3586",
    "data-name": "Path 3586",
    d: "M78.524,39.263A39.262,39.262,0,1,1,39.262,0,39.263,39.263,0,0,1,78.524,39.263Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3755",
    "data-name": "Group 3755",
    transform: "translate(30.046 25.677)",
    clipPath: "url(#clip-path-2-painscore0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3588",
    "data-name": "Path 3588",
    d: "M25.529-48.256H33.1v7.575H25.529Z",
    transform: "translate(-26.683 47.101)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3757",
    "data-name": "Group 3757",
    transform: "translate(23.642 21.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3591",
    "data-name": "Path 3591",
    d: "M14.722,7.361A7.361,7.361,0,1,1,7.361,0,7.36,7.36,0,0,1,14.722,7.361Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3758",
    "data-name": "Group 3758",
    transform: "translate(39.202 21.427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3592",
    "data-name": "Path 3592",
    d: "M14.723,7.361A7.362,7.362,0,1,1,7.361,0,7.361,7.361,0,0,1,14.723,7.361Z",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3760",
    "data-name": "Group 3760",
    transform: "translate(31.601 27.233)",
    clipPath: "url(#clip-path-3-painscore0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3594",
    "data-name": "Path 3594",
    d: "M26.876-46.908H31.34v4.464H26.876Z",
    transform: "translate(-28.031 45.753)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3762",
    "data-name": "Group 3762",
    transform: "translate(42.734 26.575)",
    clipPath: "url(#clip-path-4-painscore0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3597",
    "data-name": "Path 3597",
    d: "M36.521-47.478H44.1V-39.9H36.521Z",
    transform: "translate(-37.675 46.324)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3764",
    "data-name": "Group 3764",
    transform: "translate(44.289 28.131)",
    clipPath: "url(#clip-path-5-painscore0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3600",
    "data-name": "Path 3600",
    d: "M37.868-46.13h4.464v4.464H37.868Z",
    transform: "translate(-39.022 44.976)",
    fill: "#00142e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3766",
    "data-name": "Group 3766",
    transform: "translate(33.037 41.059)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3603",
    "data-name": "Path 3603",
    d: "M0,0S.3.9,1.916,1.136A5.362,5.362,0,0,1,4.788,2.514,2.9,2.9,0,0,0,7.9,2.752c1.138-.6,1.437-1.136,2.993-1.2s2.454.419,4.07-1.138",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3767",
    "data-name": "Group 3767",
    transform: "translate(18.261 39.968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3604",
    "data-name": "Path 3604",
    d: "M45.672,0A23.764,23.764,0,0,1,22.494,19.254C8.985,19.44,2.327,13.089,0,3.588",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3768",
    "data-name": "Group 3768",
    transform: "translate(20.588 8.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3605",
    "data-name": "Path 3605",
    d: "M0,7.534S1.526,1.7,6.015.262s9.246,3.5,9.246,3.5",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3769",
    "data-name": "Group 3769",
    transform: "translate(42.674 9.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3606",
    "data-name": "Path 3606",
    d: "M0,4.072S2.514-.417,6.284.032s6.554,5.477,6.554,5.477",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#00142e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPainScore0);
export default __webpack_public_path__ + "static/media/pain_score_0.4b93b6f3.svg";
export { ForwardRef as ReactComponent };